import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { InstallPrompt } from "./InstallPrompt";
import { registerSupportServiceWorker } from "../lib/registerServiceWorker";
import { installStandaloneGestureGuard } from "../lib/standaloneGestures";

export function WorkspaceWebApp() {
  const { pathname } = useLocation();
  const staff = pathname === "/agent" || pathname.startsWith("/agent/");
  useLayoutEffect(() => installStandaloneGestureGuard(document, window), []);
  useLayoutEffect(() => {
    const manifest = document.querySelector<HTMLLinkElement>('link[rel="manifest"]');
    if (manifest) manifest.href = staff ? "/agent-manifest.webmanifest" : "/manifest.webmanifest";
    const title = document.querySelector<HTMLMetaElement>('meta[name="apple-mobile-web-app-title"]');
    if (title) title.content = staff ? "NC Agent" : "NC Support";
    registerSupportServiceWorker();
  }, [staff]);
  return <InstallPrompt key={staff ? "agent" : "customer"} />;
}
